<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title float-left" v-if="reEvaluate.id">
                                    {{$t('reEvaluation.edit.title')}}</h4>
                                <h4 class="card-title float-left" v-else>{{$t('reEvaluation.add.title')}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                                    <v-select v-model="reEvaluate.owner" label="text"
                                              :options="owners"
                                              :filterable="false"
                                              @search="onOwnerSearch"
                                              @search:focus="onOwnerFocus"
                                              :disabled="!isEditable"
                                              :class="{invalid : $v.reEvaluate.owner.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="reEvaluate && reEvaluate.owner && reEvaluate.owner.text">
                                            <div v-html="reEvaluate.owner.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.reEvaluate.owner.$error">
                                        {{$t("realEstate.validation.ownerClient")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.propertyType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="reEvaluate.evlPropertyType"
                                            :class="{invalid : $v.reEvaluate.evlPropertyType.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.reEvaluate.evlPropertyType.$error">
                                        {{$t("realEstate.validation.propertyType")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluator")}}</label>
                                    <select class="form-control" v-model="reEvaluate.employee.id"
                                            :class="{invalid: $v.reEvaluate.employee.$error}">
                                        <option value=""></option>
                                        <option :value="option.id" v-for="option in employees" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.reEvaluate.employee.$error">
                                        {{$t("realEstate.validation.evaluator")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.contractAmount")}} <span class="red">*</span></label>
                                    <numeric-input class="form-control" v-model="reEvaluate.evlContractAmount"
                                                   :class="{invalid: $v.reEvaluate.evlContractAmount.$error}"
                                                   :controls="false" :precision="2"
                                                   :disabled="isOrgTypeMib"></numeric-input>
                                    <div class="red" v-if="$v.reEvaluate.evlContractAmount.$error">
                                        {{$t("realEstate.validation.evlContractAmount")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Буюртма хат (ариза) рақами <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="reEvaluate.letterNumber"
                                           :class="{invalid : $v.reEvaluate.letterNumber.$error}"/>
                                    <div class="red" v-if="$v.reEvaluate.letterNumber.$error">
                                        Буюртма хат (ариза) рақами
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Буюртма хат (ариза) санаси <span
                                            class="red">*</span></label>
                                    <custom-date-picker
                                            class="form-control"
                                            format="dd/MM/yyyy"
                                            v-model="reEvaluate.letterDate"
                                            :date="reEvaluate.letterDate"
                                            :clear-button="true">
                                    </custom-date-picker>
                                    <div class="red" v-if="$v.reEvaluate.letterDate.$error">
                                        Буюртма хат (ариза) санаси
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("reEvaluation.field.oldRecoveryDate")}} <span
                                            class="red">*</span></label>
                                    <div :class="{invalid: $v.reEvaluate.oldRecoveryDate.$error}">
                                        <custom-date-picker
                                                class="form-control"
                                                :format="'yyyy'"
                                                :minimumView="'year'"
                                                :disabledDates="{to: new Date('01/01/2017')}"
                                                v-model="reEvaluate.oldRecoveryDate"
                                                :date="reEvaluate.oldRecoveryDate"
                                                :clear-button="true">
                                        </custom-date-picker>
                                    </div>
                                    <div class="red" v-if="$v.reEvaluate.oldRecoveryDate.$error">
                                        {{$t("reEvaluation.validation.oldRecoveryDate")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reEvaluation.field.oldRecoveryReportNumber")}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="reEvaluate.oldRecoveryReportNumber"
                                           :class="{invalid : $v.reEvaluate.oldRecoveryReportNumber.$error}"/>
                                    <div class="red" v-if="$v.reEvaluate.oldRecoveryReportNumber.$error">
                                        {{$t("reEvaluation.validation.oldRecoveryReportNumber")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reEvaluation.field.organizationName")}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="reEvaluate.organizationName"
                                           :class="{invalid : $v.reEvaluate.organizationName.$error}"/>
                                    <div class="red" v-if="$v.reEvaluate.organizationName.$error">
                                        {{$t("reEvaluation.validation.organizationName")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reEvaluation.field.orgIdentificationNumber")}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="reEvaluate.orgIdentificationNumber"
                                           :class="{invalid : $v.reEvaluate.orgIdentificationNumber.$error}"/>
                                    <div class="red" v-if="$v.reEvaluate.orgIdentificationNumber.$error">
                                        {{$t("reEvaluation.validation.orgIdentificationNumber")}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>{{$t("reEvaluation.field.docsToSubmit")}}</h4>
                                </div>
                            </div>
                            <template>
                                <DropZone
                                        code="documentDropZone" label="reEvaluation.field.docDocuments"
                                        folder="ReEvaluation" subFolder="Documents" :maxFiles=2
                                        :data="reEvaluate.documents" @change="(files) => {reEvaluate.documents = files}"
                                        :has-error="$v.reEvaluate.documents.$error"
                                />
                                <DropZone
                                        code="applicationDropZone" label="reEvaluation.field.docApplication"
                                        folder="ReEvaluation" subFolder="ApplicationForm"
                                        :data="reEvaluate.applications"
                                        @change="(files) => {reEvaluate.applications = files}"
                                        :has-error="$v.reEvaluate.applications.$error"
                                />
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="pull-right d-flex align-items-center">
                                                <label class="mr-2">Excelни юклашда устунларни созлаш </label>
                                                <button class="all-btn edit-btn" @click="showSettingsModal">
                                                  <i class="fa fa-file-excel-o"></i>
                                                  <span>Созлаш</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <template>
                                            <DropZone
                                                    code="excelFileDropZone" label="reEvaluation.field.docApplication"
                                                    folder="ReEvaluation" subFolder="ExcelFile" :maxFiles=1
                                                    :data="reEvaluate.excelFiles" :addRemoveLinks=false
                                                    :acceptedFiles="'application/excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                                            />
                                            <ExcelDropZone
                                                    ref="ExcelDropZone"
                                                    v-if="reEvaluate.oldRecoveryDate"
                                                    code="applicationDropZone" label="Excel юклаш"
                                                    folder="ApplicationForm"
                                                    :url="excelFile"
                                                    :acceptedFiles="'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                                                    :callBackData="true"
                                                    :date="reEvaluate.oldRecoveryDate"
                                                    :columnSettings="columnSettings ? columnSettings: JSON.stringify(defaultColumnSettings)"
                                                    @change="(files) => {excelImport(files)}"/>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!--v-if="reEvaluate.id && reEvaluate.id > 0"-->
                        <div class="row" v-if="showReportButton">
                            <!--<div class="row" v-if="showReportButton">-->
                            <div class="col-12 btns-box">
                                <button
                                        class="all-btn pull-right btn-sm"
                                        @click="reportDocQrCode()">
                                    <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWordQrCode")}}
                                </button>
                                <button
                                        class="all-btn pull-right btn-sm"
                                        @click="reportDoc()">
                                    <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="reportPdfQrCode()">
                                    <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="reportPdf()">
                                    <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractQrCodePdf()">
                                    <i v-if="loading.isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdfQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractPdf()">
                                    <i v-if="loading.isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdf")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractDocQrCode()">
                                    <i v-if="loading.isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWordQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        @click="contractDoc()">
                                    <i v-if="loading.isCDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWord")}}
                                </button>
                            </div>
                        </div>

                        <div v-if="reEvaluate.reEvaluationItems.length === 0" class="row">
                            <div class="col-12">
                                <div class="section-header" v-if="reEvaluate.id && reEvaluate.oldRecoveryDate">
                                    <h4 class="pull-left">Филиаллар рўйхати</h4>
                                    <button class="all-btn add-btn pull-right" @click="addReEvaluationBranchItem">Филиал
                                        қўшиш
                                    </button>
                                </div>
                                <div class="table-responsive">
                                    <div class="table-wrapper">
                                      <table class="table table-hover">
                                          <thead>
                                          <tr>
                                              <th width="3%">№</th>
                                              <th width="20%">Филиал номи</th>
                                              <th width="15%">Киритилган сана</th>
                                              <th width="40%">Томонидан яратилган</th>
                                              <!--<th width="15%">Бахоланган қиймати</th>-->
                                              <th width="100%">ЖАРАЁН</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="(branchItem, index) in reEvaluate.reEvaluationBranchItemDtos"
                                              :key="index">
                                              <td>{{index + 1}}</td>
                                              <td>
                                                  {{branchItem.owner.fullName}}
                                              </td>
                                              <td>{{new Date(branchItem.createDate) | dateFormat('DD/MM/YYYY')}}</td>
                                              <td>{{branchItem.createUserName}}</td>
                                              <!--<td>-->
                                              <!--<span>-->
                                              <!--{{branchItem.evlTotal | currency('', 2, { thousandsSeparator: ' ' })}} сум-->
                                              <!--</span>-->
                                              <!--</td>-->
                                              <td class="text-center td-actions direction-row">
                                                  <router-link tag="button"
                                                               :to="'/re-evaluation/branch-item/edit/' + branchItem.id"
                                                               v-tooltip="'Ўзгартириш'"
                                                               class="all-btn edit-btn table-action">
                                                      <i class="fa fa-edit"></i>
                                                  </router-link>

                                                  <button type="button"
                                                          class="all-btn delete-btn table-action"
                                                          v-tooltip="'Ўчириш'"
                                                          @click="showRemoveBranchItemDialog(branchItem)"
                                                  >
                                                      <i class="fa fa-times"></i>
                                                  </button>
                                              </td>
                                          </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="reEvaluate.reEvaluationItems.length > 0" class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">{{$t("reEvaluation.field.toReEvaluate")}}</h4>
                                    <button class="all-btn add-btn pull-right" @click="addReEvaluateItem">
                                        {{$t("reEvaluation.field.addItem")}}
                                    </button>
                                    <button class="all-btn pull-right mr-2" @click="calculatedExcel"
                                            :disabled="loadingExcelCalc">
                                        <i v-if="loadingExcelCalc" class="fa fa-spinner fa-spin"></i>
                                        {{$t("reEvaluation.field.calcExcel")}}
                                    </button>
                                </div>
                                <div class="table-responsive">
                                    <div class="table-wrapper">
                                      <table class="custom" style="min-width: 1200px;">
                                          <thead>
                                          <tr>
                                              <th width="2%"></th>
                                              <th width="3%">#</th>
                                              <th width="15%">{{$t('reEvaluation.item.field.name')}} <span
                                                      class="red">*</span></th>
                                              <th width="8%">{{$t('reEvaluation.item.field.balanceAcceptedDate')}} <span
                                                      class="red">*</span></th>
                                              <th width="15%">{{$t('reEvaluation.item.field.stockCode')}} <span
                                                      class="red">*</span></th>
                                              <!--<th width="10%">{{$t('reEvaluation.item.field.reEvaluateIndex')}}</th>-->
                                              <th width="10%">{{$t('reEvaluation.item.field.province')}}</th>
                                              <th width="5%">{{$t('reEvaluation.item.field.numberOfProperty')}}</th>
                                              <th width="10%">{{$t('reEvaluation.item.field.propertyNumber')}}</th>
                                              <th width="10%">{{$t('reEvaluation.item.field.oldRecoveryAmount')}} <span
                                                      class="red">*</span></th>
                                              <th width="10%">{{$t('reEvaluation.item.field.depreciationAmount')}} <span
                                                      class="red">*</span></th>
                                              <th width="10%">{{$t('reEvaluation.item.field.residualAmount')}}</th>
                                              <th></th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="(item, index) in resultItems" :key="index">
                                              <td class="text-center">
                                                  <button class="all-btn p-2 mx-auto" @click="addReEvaluateItem"
                                                          v-tooltip="'Яратиш'"
                                                  >
                                                      <i class="fa fa-plus"></i></button>
                                              </td>
                                              <td>{{(index + 1) + getPageIndex}}</td>
                                              <td>
                                                  <input type="text" class="form-control"
                                                         :class="{invalid: $v.resultItems.$each[index].name.$error}"
                                                         v-model="item.name"
                                                  />
                                              </td>
                                              <td class="text-center">
                                                  <div :class="{invalid: $v.resultItems.$each[index].balanceAcceptedDate.$error}">
                                                      <custom-date-picker
                                                              class="form-control"
                                                              format="dd/MM/yyyy"
                                                              v-model="item.balanceAcceptedDate"
                                                              :date="item.balanceAcceptedDate"
                                                              :clear-button="true">
                                                      </custom-date-picker>
                                                  </div>
                                              </td>
                                              <td>
                                                  <div :class="{invalid: $v.resultItems.$each[index].stockCode.$error}">
                                                      <treeselect class="form-control"
                                                                  v-model="item.stockCode"
                                                                  placeholder="Танланг..."
                                                                  :multiple="false"
                                                                  :disable-branch-nodes="true"
                                                                  :options="indexes"
                                                                  value-format="object"
                                                                  @input="onChangeIndex(item)"/>
                                                  </div>
                                              </td>
                                              <td>
                                                  <v-select v-model="item.province" label="name"
                                                            :options="provinces"
                                                            :filterable="false"
                                                            @input="onChangeIndex(item)">
                                                      <template slot="option" slot-scope="option" v-if="option">
                                                          <div v-html="option.name"></div>
                                                      </template>
                                                      <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                  </v-select>

                                              </td>
                                              <td class="text-right">
                                                  <numeric-input :precision="2"
                                                                 v-model="item.numberOfProperty"
                                                  ></numeric-input>
                                              </td>
                                              <td class="text-right">
                                                  <input class="form-control" type="text" v-model="item.propertyNumber"/>
                                              </td>
                                              <td class="text-right">
                                                  <numeric-input :precision="2" v-model="item.oldRecoveryAmount"
                                                                 :class="{invalid: $v.resultItems.$each[index].oldRecoveryAmount.$error}"
                                                                 @input="calculatedResidualAmount(item)"
                                                  ></numeric-input>
                                              </td>
                                              <td class="text-right">
                                                  <numeric-input :precision="2" v-model="item.depreciationAmount"
                                                                 @input="calculatedResidualAmount(item)"
                                                                 :class="{invalid: $v.resultItems.$each[index].depreciationAmount.$error}"
                                                  ></numeric-input>
                                              </td>
                                              <td class="text-right">
                                                  <numeric-input :precision="2" v-model="item.residualAmount"
                                                  ></numeric-input>
                                              </td>
                                              <td class="text-center">
                                                  <button class="all-btn delete-btn p-2 mx-auto"
                                                          v-tooltip="'Ўчириш'"
                                                          @click="showRemoveItemDialog(item)"
                                                  >
                                                      <i class="fa fa-times"></i>
                                                  </button>
                                              </td>
                                          </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2" v-if="results && results.total && results.total > 1">
                            <div class="col-md-10 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="itemFilter.page.page"
                                              :per-page="itemFilter.page.size" @change="onPageChange"></b-pagination>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <select class="form-control" @change="changePageSize">
                                        <option value="10">10 per page</option>
                                        <option value="20">20 per page</option>
                                        <option value="50">50 per page</option>
                                        <option value="100">100 per page</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing" v-if="canSave">
                                    {{$t("action.save")}}
                                </button>
                                <button class="all-btn" @click="changeStatus('Evaluated')"
                                        :disabled="processing" v-if="canReEvaluate">{{$t("realEstate.action.evaluate")}}
                                </button>
                                <button class="all-btn add-btn" @click="changeStatus('Confirmed')"
                                        :disabled="processing" v-if="canConfirm">{{$t("realEstate.action.confirm")}}
                                </button>
                                <button class="all-btn edit-btn" @click="changeStatus('NotFullyEvaluated')"
                                        :disabled="processing" v-if="canReReEvaluate">
                                    {{$t("realEstate.action.reevaluate")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ExcelSettingsModal @change="excelSettingsDone"></ExcelSettingsModal>
    </div>
</template>

<script>
    import {required, requiredUnless, minValue, minLength} from 'vuelidate/lib/validators';
    import {EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    // import DatePicker from 'vuejs-datepicker';
    import DropZone from '@/views/dropZone/DropZone'
    import ExcelDropZone from '@/views/re-evaluation/ExcelDropZone'
    import {/*formatDate,*/ parseDate} from '@/shared/utils';
    import CustomDatePicker from '@/views/common/CustomDatePicker'
    import Treeselect from '@riophae/vue-treeselect';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import ExcelSettingsModal from './ExcelSettingsModal'
    import {EXCEL_SETTINGS} from '@/shared/constants/reEvaluateSettings'

    export default {
        components: {
            // DatePicker: DatePicker,
            DropZone: DropZone,
            ExcelDropZone,
            CustomDatePicker,
            Treeselect,
            'b-pagination': bPagination,
            ExcelSettingsModal
        },
        data() {
            return {
                columnSettings: null,
                defaultColumnSettings: EXCEL_SETTINGS.map((result, index) => ({code: result.code, order: index + 1})),
                parseDate: parseDate,
                processing: false,
                loading: {
                    isDocQrLoading: false,
                    isDocLoading: false,
                    isPdfLoading: false,
                    isPdfQrLoading: false,
                    isCDocLoading: false,
                    isCPdfLoading: false,
                    isCDocQrLoading: false,
                    isCPdfQrLoading: false,
                    itemListLoading: false
                },
                ownerFilter: initFilterModel(),
                editIndex: null,
                loadingExcelCalc: false,
                reEvaluate: {
                    id: null,
                    owner: null,
                    evlPropertyType: '',
                    employee: {},
                    evlContractAmount: 0,
                    oldRecoveryDate: null,
                    oldRecoveryReportNumber: '',
                    organizationName: '',
                    orgIdentificationNumber: '',
                    letterNumber: '',
                    letterDate: null,
                    reEvaluationBranchItemDtos: [],
                    reEvaluationItems: [],
                    documents: [],
                    applications: [],
                    excelFiles: [],
                    status: 'Pending'
                },
                owners: [],
                employees: [],
                propertyTypes: EVL_PROPERTY_TYPES,
                oldRecoveryDate: null,
                model: {
                    disabledDates: {}
                },
                provinces: [],
                indexes: [],
                excelFile: 're-evaluate/upload-excel',
                resultItems: [],
                itemFilter: initFilterModel(),
                results: null
            }
        },
        validations() {
            return {
                reEvaluate: {
                    owner: {
                        required: required
                    },
                    evlPropertyType: {
                        required: required
                    },
                    employee: {
                        id: {
                            required: required
                        }
                    },
                    evlContractAmount: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    oldRecoveryDate: {
                        required: required
                    },
                    oldRecoveryReportNumber: {
                        required: required
                    },
                    organizationName: {
                        required: required
                    },
                    orgIdentificationNumber: {
                        required: required
                    },
                    documents: {
                        required: required,
                        minLength: minLength(1)
                    },
                    applications: {
                        required: required,
                        minLength: minLength(1)
                    },
                    letterNumber: {
                        required: required,
                    },
                    letterDate: {
                        required: required,
                    },
                    reEvaluationItems: {
                        required: requiredUnless(() => {
                            return (this.isOld)
                        }),
                        minLength: minLength(1),
                        $each: {
                            name: {
                                required: required
                            },
                            stockCode: {
                                required: required
                            },
                            oldRecoveryAmount: {
                                required: required,
                                minValue: minValue(0.01)
                            },
                            depreciationAmount: {
                                required: required,
                                minValue: minValue(0)
                            },
                            balanceAcceptedDate: {
                                required: required
                            }
                        }
                    }
                },
                resultItems: {
                    required: requiredUnless(() => {
                        return (this.isOld)
                    }),
                    minLength: minLength(1),
                    $each: {
                        name: {
                            required: required
                        },
                        stockCode: {
                            required: required
                        },
                        oldRecoveryAmount: {
                            required: required,
                            minValue: minValue(0.01)
                        },
                        depreciationAmount: {
                            required: required,
                            minValue: minValue(0)
                        },
                        balanceAcceptedDate: {
                            required: required
                        }
                    }
                }
            }
        },
        methods: {
            init() {
                const vm = this;

                const promises = [
                    this.$http.get('/re-evaluate/init')
                ];
                const id = this.$route.params.id;
                if (id && id > 0) {
                    promises.push(this.$http.get('/re-evaluate/edit/' + id));
                }

                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.employees = initData.employees;
                    vm.provinces = initData.provinces;

                    if (values.length >= 2) {
                        const editData = values[1].data;
                        if (editData.reEvaluationItems && editData.reEvaluationItems.length > 0) {
                            editData.reEvaluationItems.forEach((item) => {
                                if (!item.province) {
                                    item.province = {}
                                }
                            })
                        }

                        if (!editData.employee) {
                            editData.employee = {};
                        }
                        vm.reEvaluate = editData;
                        vm.initItemList();
                    }
                    vm.initIndexes();
                });
            },
            initIndexes() {
                const vm = this;
                this.$http.get('/re-evaluate-index/re-evaluate-group-type')
                    .then(res => {
                        vm.indexes = res.data;
                    }, (err) => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            initItemList() {
                const result = {
                    total: this.reEvaluate.reEvaluationItems.length
                };
                this.results = result
                this.resultItems = this.itemFilterByPage
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('/re-evaluate/save', this.reEvaluate)
                    .then(res => {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.reEvaluation.success'),
                            type: 'success'
                        });
                        this.reEvaluate.id = res.data.data.id;
                        this.$router.push('/re-evaluation/edit/' + res.data.data.id);
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.reEvaluation.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })

            },
            cancel() {
                this.$router.push('/re-evaluation')
            },
            onOwnerSearch(searchTxt, loading) {
                loading(true);
                this.owners = [];
                this.ownerFilter.search = searchTxt;
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onOwnerFocus() {
                this.owners = [];
                this.ownerFilter.search = '';
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            addReEvaluateItem() {
                this.reEvaluate.reEvaluationItems.push({
                    name: '',
                    stockCode: null,
                    balanceAcceptedDate: null,
                    numberOfProperty: 1,
                    propertyNumber: '',
                    oldRecoveryAmount: 0,
                    depreciationAmount: 0,
                    reEvaluateIndex: 0,
                    province: {},
                    residualAmount: 0
                });
                this.editIndex = this.reEvaluate.reEvaluationItems.length - 1;
                this.resultItems = this.itemFilterByPage
                this.initItemList();
            },
            addReEvaluationBranchItem() {
                this.$router.push('/re-evaluation/branch-item/new/' + this.reEvaluate.id);
            },
            showRemoveItemDialog(item) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.reEvaluation.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.editIndex = null;
                        this.reEvaluate.reEvaluationItems.splice(this.reEvaluate.reEvaluationItems.indexOf(item), 1);
                        this.initItemList()
                    }
                });
            },
            showRemoveBranchItemDialog(item) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.reEvaluation.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value && result.value != null) {
                        if (item.id) {
                            this.processing = true;
                            this.$http.delete('re-evaluation-branch-item/delete/' + item.id)
                                .then((res) => {
                                    if (res && res.data && res.data.status === 'SUCCESS') {
                                        this.$swal({
                                            title: this.$t('messages.common.success'),
                                            text: "Қайта бахолаш қатори муваффақиятли ўчирилди.",
                                            type: 'success'
                                        });
                                        window.location.reload();
                                    } else {
                                        this.$swal({
                                            title: this.$t('messages.common.warning'),
                                            text: res.data.message,
                                            type: 'warning'
                                        });
                                    }
                                    this.processing = false;
                                }, () => {
                                    this.$swal({
                                        title: this.$t('messages.common.error'),
                                        text: "Қайта бахолаш қаторини ўчиришда хатолик юз берди",
                                        type: 'error'
                                    });
                                    this.processing = false;
                                });
                        }
                    }
                });
            },
            onChangeIndex(item) {
                let provinceId = item.province != null ? item.province.id : null;
                if (!(item.stockCode && item.stockCode.parent && (item.stockCode.parent.code === 'INDEX_10000_10018' || item.stockCode.parent.code === 'INDEX_20000_20382'))) {
                    item.province = null;
                    provinceId = null;
                }

                const data = {
                    code: item.stockCode != null ? item.stockCode.code : null,
                    balanceAcceptedDate: item.balanceAcceptedDate,
                    year: this.reEvaluate.oldRecoveryDate,
                    provinceId: provinceId
                };

                this.$http.post('/re-evaluate-index/index', data)
                    .then(res => {
                        const data = res.data;
                        const key = this.getIndex(data);
                        const indexDto = data[key];
                        if (indexDto) {
                            item.stockCode = indexDto.indexGroupType;
                        }
                        console.log(indexDto);
                    }, err => {
                        console.log(err);
                    });


            },
            getIndex(data) {
                for (const key in data) {
                    return key;
                }
            },
            calculatedExcel() {
                this.loadingExcelCalc = true;

                this.$http.post('re-evaluate/calculated-to-excel/xls', this.reEvaluate, {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/xlsx'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Кайта_бахолаш_калкулатция.xlsx';
                        link.click();
                        this.loadingExcelCalc = false
                    }).catch(e => {
                    console.log(e)
                    this.loadingExcelCalc = false
                });
            },
            reportPdf: function () {
                this.loading.isPdfLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateReport/pdf/' + this.reEvaluate.id + '/WITH_SIGNATURE',
                    'Хисобот ' + this.reEvaluate.owner.fullName + '.pdf',
                    'application/pdf',
                    'isPdfLoading');
            },
            reportPdfQrCode: function () {
                this.loading.isPdfQrLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateReport/pdf/' + this.reEvaluate.id + '/WITH_QR_CODE',
                    'Хисобот ' + this.reEvaluate.owner.fullName + '.pdf',
                    'application/pdf',
                    'isPdfQrLoading');
            },
            reportDoc: function () {
                this.loading.isDocLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateReport/doc/' + this.reEvaluate.id + '/WITH_SIGNATURE',
                    'Хисобот ' + this.reEvaluate.owner.fullName + '.doc',
                    'application/doc',
                    'isDocLoading');
            },
            reportDocQrCode: function () {
                this.loading.isDocQrLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateReport/doc/' + this.reEvaluate.id + '/WITH_QR_CODE',
                    'Хисобот ' + this.reEvaluate.owner.fullName + '.doc',
                    'application/doc',
                    'isDocQrLoading');
            },
            contractDocQrCode: function () {
                this.loading.isCDocQrLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateContract/doc/' + this.reEvaluate.id + '/WITH_QR_CODE',
                    'Шартнома ' + this.reEvaluate.owner.fullName + '.doc',
                    'application/doc',
                    'isCDocQrLoading');
            },
            contractDoc: function () {
                this.loading.isCDocLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateContract/doc/' + this.reEvaluate.id + '/WITH_SIGNATURE',
                    'Шартнома ' + this.reEvaluate.owner.fullName + '.doc',
                    'application/doc',
                    'isCDocLoading');
            },
            contractPdf: function () {
                this.loading.isCPdfLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateContract/pdf/' + this.reEvaluate.id + '/WITH_SIGNATURE',
                    'Шартнома ' + this.reEvaluate.owner.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfLoading');
            },
            contractQrCodePdf: function () {
                this.loading.isCPdfQrLoading = true;
                this.downloadFile('/re-evaluate/reEvaluateContract/pdf/' + this.reEvaluate.id + '/WITH_QR_CODE',
                    'Шартнома ' + this.reEvaluate.owner.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfQrLoading');
            },
            downloadFile: function (url, name, type, loading) {
                this.$http.get(url, {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: type});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = name;
                        link.click();
                        this.loading[loading] = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading[loading] = false;
                    })
            },
            changeStatus(status) {
                this.processing = true;
                this.$http.post('re-evaluate/status', {
                    id: this.reEvaluate.id,
                    status: status,
                }).then(res => {
                    if (res && res.data) {
                        if (res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('asset.statusSuccess'),
                                type: 'success'
                            });
                            this.reEvaluate.status = status;
                        } else if (res.data.status === 'ERROR' || res.data.status === 'NOT_FOUND') {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('asset.statusWarning'),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('asset.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                });
            },
            excelImport(data) {
                console.log("data", data)
                const vm = this;
                data.forEach((item) => {
                    const addItem = {
                        name: item.name,
                        stockCode: item.stockCode,
                        balanceAcceptedDate: item.balanceAcceptedDate,
                        numberOfProperty: item.numberOfProperty && item.numberOfProperty > 0 ? item.numberOfProperty : 1,
                        propertyNumber: item.propertyNumber,
                        oldRecoveryAmount: item.oldRecoveryAmount,
                        depreciationAmount: item.depreciationAmount,
                        residualAmount: item.residualAmount && item.residualAmount > 0 ? item.residualAmount : item.oldRecoveryAmount - (item.depreciationAmount ? item.depreciationAmount:0),
                        reEvaluateIndex: 0,
                        province: item.province
                    };

                    vm.reEvaluate.reEvaluationItems.push(addItem);
                    vm.initItemList();

                });

            },
            onPageChange(page) {
                this.itemFilter.page.page = page
                this.initItemList()
            },
            changePageSize($event) {
                this.itemFilter.page.size = Number($event.target.value);
                this.initItemList()
            },
            showSettingsModal() {
                this.$eventBus.$emit("showSettings")
            },
            excelSettingsDone(value) {
                console.log(JSON.stringify(value))
                this.columnSettings = JSON.stringify(value);
            },
            calculatedResidualAmount(item) {
                if (item.oldRecoveryAmount) {
                    item.residualAmount = item.oldRecoveryAmount - item.depreciationAmount;
                } else {
                    item.residualAmount = 0
                }
            }
        },
        computed: {
            isEditable() {
                return this.reEvaluate.status !== 'Confirmed';
            },
            canSave() {
                return (this.reEvaluate.status === 'Pending' || this.reEvaluate.status === 'AssignedToEvaluator' || this.reEvaluate.status === 'NotFullyEvaluated');
            },
            canConfirm() {
                return this.reEvaluate.status === 'Evaluated' && this.hasPermission('RE_EVALUATE_CONFIRM');
            },
            canReEvaluate() {
                return (this.reEvaluate.status === 'NotFullyEvaluated') && this.hasPermission('RE_EVALUATE_EVALUATE');
            },
            canReReEvaluate() {
                return (this.reEvaluate.status === 'Evaluated' || this.reEvaluate.status === 'Confirmed') && this.hasPermission('RE_EVALUATE_REEVALUATE');
            },
            showReportButton() {
                return (this.reEvaluate.status === 'Evaluated' || this.reEvaluate.status === 'Confirmed') && this.reEvaluate.id && this.reEvaluate.id > 0;
            },
            getPageIndex() {
                return (this.itemFilter.page.page - 1) * this.itemFilter.page.size
            },
            itemFilterByPage() {
                return this.reEvaluate.reEvaluationItems.slice(this.getPageIndex, this.getPageIndex + this.itemFilter.page.size)
            },
            isOrgTypeMib() {
                return !!(this.reEvaluate.owner &&
                    this.reEvaluate.owner.organizationType &&
                    (this.reEvaluate.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.reEvaluate.owner.organizationType === 'CUSTOMS_ADMINISTRATION'));
            },
            isOld() {
                return !(this.reEvaluate.reEvaluationItems && this.reEvaluate.reEvaluationItems.length > 0)
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    .custom td, .custom th {
        border: 1px solid #ddd;
        padding: 4px;
    }

    .custom tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    .custom tr:hover {
        opacity: 1;
        background-color: #dee2e6;
    }

    .custom thead tr th {
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }

    .custom tr {
        font-size: 14px;
    }

</style>